module.exports = __webpack_public_path__ + "static/media/state-banner-2.89222dbc.png";